"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var qrcode_react_1 = __importDefault(require("qrcode.react"));
var QRCodeWidget = function (_a) {
    var _b = _a.qrCodeProps, size = _b.size, value = _b.value, backgroundColor = _b.backgroundColor, codeColor = _b.codeColor;
    var spacing = size / 27;
    var qRCodeSize = 25 * spacing;
    return (react_1.default.createElement("div", { style: {
            background: backgroundColor,
            borderRadius: "".concat(spacing, "px"),
            height: '100%',
            width: '100%',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center'
        } },
        react_1.default.createElement(qrcode_react_1.default, { value: value, size: qRCodeSize, bgColor: backgroundColor, fgColor: codeColor })));
};
exports.default = QRCodeWidget;
//# sourceMappingURL=QRCodeWidget.js.map